/** Tiny runtime narrowing helpers shared across API / SSE / bridge parsing. */

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}
